<template>
	<div class="rank">
		 <div class="navBox">
			<div :class="[index == active ? 'active' : '']" v-for="(item,index) in navList" @click="toggleNav(index)">{{ item.name }}</div>
		</div>  
		<div class="rankBox">

			<div class="rankBox_tips">*本榜单数据每日实时更新</div>
			 <div class="rankBox-module" v-if="navList[active].type == 1 && alist.length != 0">
				<div class="rankBox-module-my" v-if="myData1 != ''">
					<div class="rankBox-module-my-img">
						<img v-if="myData1 != ''" :src="myData1.avatarurl" alt="">
					</div>
					<div class="rankBox-module-my-rank">
						<div class="myname1">{{ myData1 != '' ? myData1.nickname : '' }}</div>
						<div class="myname2">排名：第{{ myData1 != '' ? myData1.rank : '' }}位 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;得分：{{ myData1.total_score }}  分</div>
					</div>
				</div>
				<div class="rankBox-module-header">
					<div class="label01">排名</div>
					<div class="label02">用户名</div>
					<div class="label03">项目得分/个数</div>
				</div>
				<div class="list">
					<div class="item" v-for="(item, index) in alist" :key="index">
						<div class="item-01">
							<img v-if="index == 0" src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220622/1655872287-62b29b1f5b45f.png" alt="">
							<img v-else-if="index == 1" src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220622/1655872287-62b29b1f1f929.png" alt="">
							<img v-else-if="index == 2" src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220622/1655872287-62b29b1f3d793.png" alt="">
							<span v-else>{{ index + 1 }}</span>
						</div>
						<div class="item-02">
							<div class="item-02-img">
								<img :src="item.avatarurl" alt="">
							</div>
							<div class="item-02-txt">{{ item.nickname }}</div>
						</div>
						<div class="item-03">
							{{ item.total_score }}分
						</div>
					</div>
				</div>
			</div> 
	
			<div v-if="ismore" @click="getMore" class="moreClass" style="font-size: .24rem;border: 1px solid #eee;
	width: 2rem;
	margin: auto;
	text-align: center;
	padding: .1rem 0;
	margin-top: .2rem;">加载更多</div>
			
			
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			navList: [
				{
					name: '个人排行榜',
					type: 1,
				}
				// ,{
				// 	name: '企业排行榜',
				// 	type: 2,
				// },{
				// 	name: '团队排行榜',
				// 	type: 3,
				// }
			],
			// navList: [
			// 	{
			// 		name: '个人排行榜',
			// 		type: 1,
			// 	},
			// 	{
			// 		name: '团队排行榜',
			// 		type: 3,
			// 	}
			// ],
			active: 0,
			
			
			activity_id: 0,
			page: 1,
			
			
			alist: [],
			myData1: '',
			blist: [],
			myData2: '',
			clist: [],
			myData3: '',
			
			urid: '',
			token: '',
			gid: '',
			
			ismore:true,
			
			type: 3,
			
			
			sports_item_id: '',
			
			
		}
	},
	mounted() {
		this.activity_id = this.$route.params.id
		this.type = this.$route.params.type
		this.sports_item_id = this.$route.params.sports_item_id ? this.$route.params.sports_item_id : ''
		
		
		if(this.type == 3){
			// this.navList.push({
			// 	name: '团队排行榜',
			// 	type: 3,
			// })
			// this.activity_id = 1056
			var { urid, token, gid } = JSON.parse(window.localStorage.getItem('movehealth/default/userInfo')) 
			// var token =
			this.urid = urid
			this.token = token
			this.gid = gid
			// console.log('urid', urid)
			var data = {
			
				page: this.page,
				sports_id: this.activity_id,
				type: this.navList[this.active].type
			}
			this.getRankData2(data)
		}else if(this.type == 2){
			var { urid, token, gid } = JSON.parse(window.localStorage.getItem('movehealth/default/userInfo'))
			// var token =
			this.urid = urid
			this.token = token
			this.gid = gid
			// console.log('urid', urid)
			var data = {
			
				page: this.page,
				sports_id: this.activity_id,
				type: this.navList[this.active].type
			}
			this.getRankData2(data)
		}else{
			// this.activity_id = 1056
			var { urid, token, gid } = JSON.parse(window.localStorage.getItem('movehealth/default/userInfo')) 
			// var token =
			this.urid = urid
			this.token = token
			this.gid = gid
			// console.log('urid', urid)
			var data = {
			
				page: this.page,
				activity_id: this.activity_id,
				type: this.navList[this.active].type
			}
			this.getRankData(data)
		}
		
	},
	methods: {
		toggleNav(idx){
			this.active = idx
			this.page = 1
			this.alist = []
			this.blist = []
			this.clist = []
			this.myData1 = ''
			this.myData2 = ''
			this.myData3 = ''
			
			if(this.type == 3){
				var data = {
				
					page: this.page,
					sports_id: this.activity_id,
					type: this.navList[this.active].type
				}
				this.getRankData2(data)
			}else if(this.type == 2){
				
				var data = {
				
					page: this.page,
					sports_id: this.activity_id,
					type: this.navList[this.active].type
				}
				this.getRankData2(data)
			}else{
				
				var data = {
				
					page: this.page,
					activity_id: this.activity_id,
					type: this.navList[this.active].type
				}
				this.getRankData(data)
			}
			
			
			
		},
		
		getRankData(data){
			data.gid = this.gid
			data.token = this.token
			data.urid = this.urid
			
			this.$api.answer
				.getRankData(data)
				.then((res) => {
					if(res.code == 200){
						
						if(this.navList[this.active].type == 1){
							this.myData1 = res.data.my == null ? '' : res.data.my
							console.log('myData1', this.myData1)
							// res.data.list = [1,1,1,1,1,1,1,1,1,1,11,1,1,1]
							this.alist = this.alist.concat(res.data.list) 
							
							if(this.alist.length < 40 && this.page == 1){
								this.ismore = false
							}else{
								this.ismore = true
							}	
							console.log(this.alist,'11')
							
						}
						if(this.navList[this.active].type == 2){
							this.myData2 = res.data.my == null ? '' : res.data.my
							this.blist = this.blist.concat(res.data.list) 
							if(this.blist.length < 40 && this.page == 1){
								this.ismore = false
							}else{
								this.ismore = true
							}
							console.log(this.blist,'this.blist')
						}
						if(this.navList[this.active].type == 3){
							this.myData3 = res.data.my  == null ? '' : res.data.my
							this.clist = this.clist.concat(res.data.list) 
							console.log(this.clist,'this.clist')
							if(this.clist.length < 40 && this.page == 1){
								this.ismore = false
							}else{
								this.ismore = true
							}
						}
					}
				})
		},
		getMore(){
			this.page = this.page + 1
			if(this.type = 1){
				var data = {
				
					page: this.page,
					activity_id: this.activity_id,
					type: this.navList[this.active].type
				}
				this.getRankData(data)
			}else{
				var data = {
				
					page: this.page,
					sports_id: this.activity_id,
					type: this.navList[this.active].type
				}
				this.getRankData2(data)
			}
		},
		
		getRankData2(data){
			data.gid = this.gid
			data.token = this.token
			data.urid = this.urid
			data.sports_item_id = this.sports_item_id
			this.$api.answer
				.getRankData2(data)
				.then((res) => {
					if(res.code == 200){
						
						if(this.navList[this.active].type == 1){
							this.myData1 = res.data.my == null ? '' : res.data.my
							// res.data.list = [1,1,1,1,1,1,1,1,1,1,11,1,1,1]
							this.alist = this.alist.concat(res.data.list) 
							
							if(this.alist.length < 40 && this.page == 1){
								this.ismore = false
							}else{
								this.ismore = true
							}
							
						}
						if(this.navList[this.active].type == 3){
							this.myData2 = res.data.my == null ? '' : res.data.my
							this.blist = this.blist.concat(res.data.list) 
							if(this.blist.length < 40 && this.page == 1){
								this.ismore = false
							}else{
								this.ismore = true
							}
						}
						if(this.navList[this.active].type == 2){
							this.myData3 = res.data.my == null ? '' : res.data.my
							this.clist = this.clist.concat(res.data.list) 
							if(this.clist.length < 40 && this.page == 1){
								this.ismore = false
							}else{
								this.ismore = true
							}
						}
					}
				})
		}
		
	}
}
</script>

<style lang="less" scoped>
.navBox{
	background: #fff;
	height: 1.02rem;
	line-height: 1.02rem;
	// opacity: 0.45;
	font-family: PingFangTC-Regular;
	font-size: .28rem;
	color: rgba(0,0,0,0.45);
	letter-spacing: 0;
	text-align: center;
	font-weight: 400;
	display: flex;
	div{
		flex-grow: 1;
	}
	.active{
		font-size: .34rem;
		color: rgba(0,0,0,0.85);
		border-bottom: 1px solid #FF6900;
	}
}
.rankBox{
	width: 7.13rem;
	margin: auto;
	// height: 1232px;
	background: #FFFFFF;
	border-radius: .10rem;
	margin-top: .24rem;
	box-sizing: border-box;
	padding: 0 .24rem .4rem .24rem;
	
	.img02{
		width: 2.8622rem;
		height: .65rem;
		margin: auto;
		
		img{
			width: 2.8622rem;
			height: .65rem;
			position: relative;
			top: -0.65rem
			// margin-top: -20px;
		}
	}
	.rankBox_tips{
		text-align: center;
		font-size: .22rem;
		color: #FA653A;
		letter-spacing: 0;
		font-weight: 400;	
	}
	.rankBox-module{
		margin-top: .15rem;
		.rankBox-module-my{
			width: 100%;
			// height: 157px;
			background: #FFEDD5;
			border-radius: .22rem;
			box-sizing: border-box;
			padding: .2rem .4rem;
			display: flex;
			align-items: center;
			.rankBox-module-my-img{
				width: 1.04rem;
				height: 1.04rem;
				margin-right: .45rem;
				img{
					width: 1.04rem;
					height: 1.04rem;
					border-radius: 50%
				}
			}
			.rankBox-module-my-rank{
				
				.myname1{
					font-size: .28rem;
					color: #FC6241;
					letter-spacing: 0;
					font-weight: 600;
				}
				.myname2{
					font-size: .24rem;
					color: #FC6241;
					letter-spacing: 0;
					font-weight: 400;
					margin-top: .2rem;
				}
			}
		}
		.rankBox-module-header{
			width: 100%;
			background-image: linear-gradient(0deg, #FC5F43 0%, #FF8B1F 100%);
			border-radius: .31rem;
			font-size: .20rem;
			color: #FFFFFF;
			font-weight: 600;
			display: flex;
			padding: .1rem .4rem;
			box-sizing: border-box;
			margin-top: .3rem;
		}
	}
	
}
.label01{
	width: 20%;			
}
.label02{
	width: 56%;					
}
.label03{
	width: 24%;					
}
.list{
	.item{
		width: 100%;
		color: #FFFFFF;
		display: flex;
		padding: .2rem .4rem;
		box-sizing: border-box;
		font-size: .1rem;
		align-items: center;
		// margin-top: .3rem;
	}
}
.item-01{
	width: 20%;	
	img{
		width: .385rem
	}
	span{
		display: inline-block;
		width: .385rem;
		text-align: center;
		font-size: .26rem;
		color: #666666;
		letter-spacing: 0;
		text-align: center;
		font-weight: 400;
	}
}
.item-02{
	width: 56%;	
	display: flex;
	align-items: center;
	.item-02-img{
		width: .71rem;
		height: .71rem;
		margin-right: .2rem;
		img{
			width: .71rem;
			height: .71rem;
			border-radius: 50%
		}
	}
	.item-02-txt{
		font-size: .28rem;
		color: #FF835B;
		letter-spacing: 0;
		font-weight: 500;
	}
}
.item-03{
	width: 24%;
	font-size: .28rem;
	color: #4A4A4A;
	letter-spacing: 0;
	text-align: right;
	font-weight: 600;
}
.rank{
	background: #fdb77d;
	min-height: 100%;
	box-sizing: border-box;
	padding-bottom: .5rem;
}
</style>
